import { createStore, applyMiddleware } from 'redux';
import {createLogger} from 'redux-logger'
import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'

import reducer from './reducers'

export default function configureStore(initialState) {

	const middleware = applyMiddleware(promise(), thunk, createLogger())

  	const store = createStore(reducer, middleware);

  	return store;
}


// WEBPACK FOOTER //
// ./src/store/configureStore.js